import { render, staticRenderFns } from "./subscriptions_dropdown.vue?vue&type=template&id=bd54a82e"
import script from "./subscriptions_dropdown.vue?vue&type=script&lang=js"
export * from "./subscriptions_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports